import { UserOutlined } from '@ant-design/icons';

export const roles = {
    assistant: {
        placement: 'start' as const,
        avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },
    },
    user: {
        placement: 'end' as const,
        avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },
    },
};
